import { useBoolean } from '@qfa/react-components';
import { useMemo } from 'react';

export type ControlsDrawerState = {
  isOpen: boolean;
  close: () => void;
  open: () => void;
};
export const useControlsDrawerState = (): ControlsDrawerState => {
  const [{ off: closeDrawer, on: openDrawer }, isControlsDrawerOpen] = useBoolean(false);

  return useMemo(
    () => ({
      isOpen: isControlsDrawerOpen,
      close: closeDrawer,
      open: openDrawer,
    }),
    [closeDrawer, isControlsDrawerOpen, openDrawer]
  );
};
